var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39776 11.9948C1.8935 11.9436 1.5 11.5178 1.5 11V1C1.5 0.447715 1.94772 0 2.5 0H9.5C10.0523 0 10.5 0.447716 10.5 1V1.2H2.7V12H2.5C2.46548 12 2.43137 11.9983 2.39776 11.9948Z",
    fill: "#4F5F72",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 13C3.5 13.5178 3.8935 13.9436 4.39776 13.9948C4.43137 13.9983 4.46548 14 4.5 14H11.5C12.0523 14 12.5 13.5523 12.5 13L12.5 3C12.5 2.44772 12.0523 2 11.5 2H4.5C3.94772 2 3.5 2.44772 3.5 3V13ZM4.9 3.4L11.1 3.4L11.1 12.6L4.9 12.6V3.4Z",
    fill: "#4F5F72",
    fillOpacity: 0.32
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGrey);
export default __webpack_public_path__ + "static/media/copy_grey.0c96ef9d.svg";
export { ForwardRef as ReactComponent };